import { colors } from "@vericus/cadmus-ui";

import { IPastAssessment } from "@/data/templates";
import { AssessmentType, TaskKind } from "@/generated/graphql";
import { isGroupAssessment } from "@/graphql/assessment-settings-selectors";
import { DisplayTag } from "@/ui/StudentLists/TagSelector";

/** Generate display tags for a past assessment */
export function generateTags(pastAssessment: IPastAssessment): DisplayTag[] {
  const tags: DisplayTag[] = [
    {
      value: "released",
      active: true,
      color: colors.green200,
    },
  ];

  const examEndDate = pastAssessment.settings?.examEndDate
    ? new Date(pastAssessment.settings.examEndDate)
    : null;

  const dueDate = pastAssessment.settings?.dueDate
    ? new Date(pastAssessment.settings.dueDate)
    : null;

  if (pastAssessment.settings.assessmentType === AssessmentType.Exam) {
    if (examEndDate && new Date() > examEndDate) {
      tags.push({
        value: "closed",
        active: true,
        color: colors.grey100,
      });
    }
  } else if (dueDate && new Date() > dueDate) {
    tags.push({
      value: "closed",
      active: true,
      color: colors.grey100,
    });
  }

  tags.push({
    value: pastAssessment.taskFormat,
    active: true,
    color: colors.purple200,
  });

  if (isGroupAssessment(pastAssessment.settings)) {
    if (pastAssessment.taskKind === TaskKind.Individual) {
      tags.push({
        value: "individual",
        active: true,
        color: colors.blue200,
      });
    } else if (pastAssessment.taskKind === TaskKind.Peer) {
      tags.push({
        value: "peer evaluation",
        active: true,
        color: colors.blue200,
      });
    } else {
      tags.push({
        value: "group",
        active: true,
        color: colors.blue200,
      });
    }
  }

  return tags;
}
